import {
    StaffCompanyGeneralDataRequest,
    StaffCompanyRequest,
    StaffCompanyResponse,
} from 'lib-klab-sdks';
import {
    Company,
    CompanyGeneralDataRequest,
    CompanyUpsertRequest,
} from '../../../domain/models/organization/company.model';

export function mapStaffCompanyToDomain(company: StaffCompanyResponse): Company {
    return {
        id: company.id,
        name: company.name,
        tradeName: company.tradeName,
        documentNumber: company.documentNumber,
        address: company.address,
        logoUrl: company.logoUrl,
        phone: company.phone,
        email: company.email,
        status: company.status,
        interior: company.interior ?? null,
        postalCode: company.postalCode ?? null,
        districtCode: company.districtCode ?? null,
        urbanArea: company.urbanArea ?? null,
        phoneCountryCode: company.phoneCountryCode ?? null,
        secondaryPhoneCountryCode: company.secondaryPhoneCountryCode ?? null,
        secondaryPhone: company.secondaryPhone ?? null,
        registryNumber: company.registryNumber ?? null,
        generalDataConfigured: company.generalDataConfigured ?? false,
    };
}

export function mapCompanyGeneralDataRequestToSdk(
    request: CompanyGeneralDataRequest,
): StaffCompanyGeneralDataRequest {
    return { ...request };
}

export function mapCompanyRequestToSdk(
    request: CompanyUpsertRequest,
): StaffCompanyRequest {
    return {
        name: request.name,
        tradeName: request.tradeName,
        documentNumber: request.documentNumber,
        address: request.address,
        phone: request.phone,
        email: request.email,
    };
}
